const HEALTHY_CONNECTION_STATUSES = new Set(['connected', 'active', 'current', 'rotated']);

export function getBrokerConnectionStatus(item) {
  const structuredStatus = typeof item?.connectionStatus === 'string'
    ? item.connectionStatus.trim().toLowerCase()
    : '';
  if (structuredStatus) {
    return HEALTHY_CONNECTION_STATUSES.has(structuredStatus)
      ? 'connected'
      : structuredStatus;
  }
  const legacyStatus = typeof item?.status === 'string'
    ? item.status.trim().toLowerCase()
    : '';
  if (item?.reconnectRecommended === true || legacyStatus === 'reconnect_required') {
    return legacyStatus && !HEALTHY_CONNECTION_STATUSES.has(legacyStatus)
      ? legacyStatus
      : 'reconnect_required';
  }
  if (legacyStatus && !HEALTHY_CONNECTION_STATUSES.has(legacyStatus)) {
    return legacyStatus;
  }
  return 'connected';
}

export function brokerConnectionNeedsAttention(item) {
  return getBrokerConnectionStatus(item) !== 'connected';
}

export function getBrokerConnectionStatusLabel(item) {
  const status = getBrokerConnectionStatus(item);
  if (status === 'provider_unavailable') return 'Broker unavailable';
  if (status === 'platform_configuration_error' || status === 'unknown_error') {
    return 'Connection problem';
  }
  return status === 'reconnect_required' ? 'Needs reconnect' : '';
}

export function getBrokerConnectionWarning(item) {
  const status = getBrokerConnectionStatus(item);
  if (status === 'provider_unavailable') {
    return 'This broker connection is unavailable. Try reconnecting before starting bots.';
  }
  if (status === 'platform_configuration_error' || status === 'unknown_error') {
    return 'Reconnect this account. If the problem continues, BotSpot needs attention.';
  }
  return status === 'reconnect_required'
    ? 'Reconnect before starting bots with this account.'
    : '';
}
